export default __webpack_public_path__ + "static/media/apoie_2400.52fdc5e7.webp";